<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ $t('sections.title') }}</div>
      <v-spacer></v-spacer>
      <div class="d-flex justify-end align-center mr-3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar sección por nombre"
          solo
          hide-details
          rounded
          flat
          dense />
      </div>
      <v-dialog @keydown.esc="createDialog=false" v-model="createDialog" persistent max-width="450px">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="restaurantId && sectionPermissions['create-section']"
            v-on="on"
            fab
            x-small
            depressed
            color="primary"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ !form.data.name ? $t('sections.create') : $t('sections.edit')}}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="sectionForm" v-model="form.valid">
              <v-container grid-list-xl>
                <v-layout wrap>
                  <v-flex xs12 md12>
                    <v-text-field
                      v-model="form.data.name"
                      :rules="form.rules.name"
                      :label="$t('sections.labels.name')"
                      maxlength="64"
                      required>
                    </v-text-field>
                    <v-select
                      :label="$t('recipes.labels.area')"
                      v-model="form.data.area"
                      :items="areas"
                      :rules="form.rules.area"
                      item-text="name"
                      item-value="_id"
                      required
                      return-object
                    />
                    <v-text-field
                      v-model="form.data.priority"
                      :rules="form.rules.priority"
                      label="Prioridad"
                      maxlength="1"
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" small @click="onCloseCreateDialog">{{ $t('ctas.close') }} </v-btn>
            <v-btn color="primary" small :disabled="!form.data.area" @click="submit">{{ $t('ctas.save') }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-flex xs12>
      <v-data-table
        v-if="restaurantId"
        loading-text="Cargando secciones"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :items-per-page="15"
        @update:options="updateTable"
        :footer-props="{
          'items-per-page-options': [15, 25, 50, 100]
        }"
        class="elevation-1 fixed-header">
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col md="3">
                <div class="d-flex align-end">
                  <span class="mr-3">
                    Filtros:
                  </span>
                  <v-select
                    v-model="areaSelected"
                    :items="areas"
                    item-value="_id"
                    item-text="name"
                    label="Áreas"
                    clearable
                    hide-details
                    dense
                    @change="filterByArea"
                    @click:clear="filterByArea"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.priority="{ item }">
          <span>{{ item.priority ? item.priority : '-'}}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-end align-center">
            <v-tooltip v-if="sectionPermissions['update-section']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="primary"
                  class="mr-2"
                  v-on="on"
                  @click="onOpenUpdateDialog(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar sección</span>
            </v-tooltip>
            <v-tooltip v-if="sectionPermissions['delete-section']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="error"
                  v-on="on"
                  @click="onOpenRemoveDialog(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar sección</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-flex
        v-else
        class="justify-center d-flex"
      >
        <div class="title">
          Selecciona un restaurant para ver sus secciones
        </div>
      </v-flex>
    </v-flex>
    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="max-content">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('sections.actions.remove', { name: form.data.name }) }}</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="onCloseRemoveDialog">No</v-btn>
          <v-btn color="primary" small @click="remove">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'

export default {
  name: 'Secctions',
  data () {
    return {
      section: 'Sections',
      deleteDialog: false,
      createDialog: false,
      removeDialog: false,
      overlay: false,
      restaurant: null,
      table: {
        title: this.$i18n.t('sections.title'),
        loading: true,
        data: [],
        headers: [
          { text: this.$i18n.t('sections.headers.name'), value: 'name', sortable: false },
          { text: 'Area', value: 'area.name', sortable: false },
          { text: 'Prioridad', value: 'priority', sortable: false },
          { text: this.$i18n.t('sections.headers.actions'), value: 'action', sortable: false }
        ],
        options: {
          page: 1,
          itemsPerPage: 15,
          sortBy: ['issuedAt'],
          sortDesc: [true],
          groupBy: [],
          groupDesc: [],
          mustSort: false,
          multiSort: false
        }
      },
      form: {
        valid: false,
        rules: {
          name: [v => !!v || `${this.$i18n.t('sections.labels.name')} ${this.$i18n.t('messages.isRequired')}`],
          area: [v => !!v || `Area ${this.$i18n.t('messages.isRequired')}`],
          priority: [
            v => (!!v && (v <= 5 && v >= 0)) || `Introduce una prioridad de 1 a 5`,
            v => /^[0-9 ]*$/g.test(v) || 'Only numbers are allowed'
          ]
        },
        data: {
          name: null,
          area: null,
          restaurant: null
        }
      },
      search: '',
      areaSelected: null,
      sectionName: null
    }
  },
  watch: {
    'search': debounce(async function (val) {
      const params = {}
      if (this.areaSelected) params.area = this.areaSelected
      if (val.length >= 2) {
        params.name = `/${val}/i`
        this.table.loading = true
        try {
          const response = await this.$api.get(`/v1/restaurants/${this.restaurantId}/sections`, params)
          this.table.data = response.data
          this.table.total = response.total
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.table.loading = false
      } else {
        this.load(params)
      }
    }, 300)
  },
  computed: {
    areas () {
      return this.$store.state.currentRestaurant.areas.data || []
    },
    restaurantId: function () { return this.$store.state.currentRestaurant.data._id || null },
    sectionPermissions () {
      return this.$store.state.login.permissions['settings'].components['sections'].actions
    }
  },
  methods: {
    resetForm () {
      this.form.data = {}
      this.areaSelected = {}
    },
    async load (params = null) {
      this.table.loading = true
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      try {
        const response = await this.$api.get(`/v1/restaurants/${this.restaurantId}/sections`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    onCloseCreateDialog () {
      this.$refs.sectionForm.reset()
      this.resetForm()
      this.createDialog = false
    },
    onOpenUpdateDialog (section) {
      this.form.data = cloneDeep(section)
      this.form.data.restaurant = this.restaurantId
      this.createDialog = true
      this.isEditing = true
    },
    onCloseUpdateDialog () {
      this.$refs.sectionForm.reset()
      this.resetForm()
      this.createDialog = false
    },
    onOpenRemoveDialog: async function (section) {
      this.form.data = cloneDeep(section)
      this.form.data.restaurant = this.restaurantId
      this.removeDialog = true
    },
    onCloseRemoveDialog () {
      if (this.$refs && this.$refs.sectionForm) this.$refs.sectionForm.reset()
      this.resetForm()
      this.removeDialog = false
    },
    submit: async function () {
      if (this.$refs.sectionForm.validate()) {
        this.overlay = true
        const request = this.form.data._id != null
          ? this.update()
          : this.create()
        try {
          await request
          await this.load()
          this.onCloseCreateDialog()
          this.createDialog = false
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    update: async function () {
      const areaId = this.form.data.area._id
      this.form.data.area = areaId
      const section = await this.$api.put(`/v1/restaurants/${this.restaurantId}/sections/${this.form.data.id}`, this.form.data)
      await this.$store.commit('currentRestaurant/sections/update', section)
    },
    remove: async function () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/restaurants/${this.restaurantId}/sections/${this.form.data.id}`)
        await this.$store.commit('currentRestaurant/sections/delete', { _id: this.form.data.id })
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.onCloseRemoveDialog()
      this.overlay = false
    },
    create: async function () {
      const areaId = this.form.data.area._id
      this.form.data.area = areaId
      const section = await this.$api.post(`/v1/restaurants/${this.restaurantId}/sections`, this.form.data)
      await this.$store.commit('currentRestaurant/sections/add', section)
    },
    async filterByArea () {
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      if (this.areaSelected) params.area = this.areaSelected

      await this.load(params)
    },
    async resetFilter () {
      this.areaSelected = {}
      await this.load()
    },
    async updateTable (data) {
      const params = {
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1))
      }

      if (this.areaSelected) params.area = this.areaSelected
      await this.load(params)
    }
  }
}
</script>
